import React from "react"

type Props = {
    script: string
}

export default function EmbedPhase({script}: Props) {
    return <div style={{display: 'flex', justifyContent: 'center'}} dangerouslySetInnerHTML={{__html: script}}></div>
}
